import $ from 'jquery';
import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';

$(document).ready(function () {

    $('.whatToDoCarousel').each(function (index, element) {
        const swiper = element.querySelector('.swiper');
        const nav = element.querySelector('.carousel__nav');
        const nextButton = element.querySelector('.carousel__next');
        const prevButton = element.querySelector('.carousel__prev');
        new Swiper(swiper, {
            modules: [Navigation, Autoplay],
            spaceBetween: 16,
            /*autoplay: {
                pauseOnMouseEnter: true
            },*/
            autoplay: true,
            loop: false,
            slidesOffsetAfter: 70,
            breakpoints: {
                720: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                    slidesOffsetAfter: 20,
                },
                1120: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                    slidesOffsetAfter: 0,
                },
                1600: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    slidesOffsetAfter: 0,
                }
            },
            navigation: {
                enabled: !!nav,
                addIcons: false,
                nextEl: nextButton,
                prevEl: prevButton,
            }
        });
    });
});